
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mubaiairporttaxibookingonline() {



    const cardData =
    {
        keyword: 'Mumbai Airport Taxi Booking Online',
        heading: 'Vedant Travels:  Mumbai Airport Taxi Booking Online',
        headingDescription: 'Need a reliable and hassle-free taxi from Mumbai Airport? Vedant Travels offers 24/7 Mumbai Airport Taxi Services, ensuring comfortable and timely pickups and drop-offs. Whether you are traveling for business, leisure, or a family trip, our well-maintained fleet of sedans, SUVs, and luxury vehicles caters to all your travel needs.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "One of Mumbai’s most iconic landmarks, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this grand structure is a must-visit for history lovers and photographers."
    },
    {
        "title": "Marine Drive & Chowpatty Beach",
        "description": "The 3.6 km-long Marine Drive is a scenic boulevard along the Arabian Sea, perfect for evening strolls. At the northern end lies Girgaum Chowpatty Beach, famous for its street food, especially pav bhaji and bhel puri."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A UNESCO World Heritage Site, CSMT is an architectural masterpiece combining Victorian Gothic and Indian styles. The beautifully lit station at night is a stunning sight."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, this temple is one of the most revered places in Mumbai. Devotees, celebrities, and tourists visit to seek blessings."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these rock-cut caves are famous for their ancient Shiva sculptures. The Maheshmurti statue, depicting Lord Shiva in three forms, is the highlight. 🚤 How to Reach? Take a ferry from the Gateway of India."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Situated on an islet in the Arabian Sea, this beautiful mosque and tomb is an architectural marvel. It is accessible via a narrow walkway during low tide."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "This modern engineering marvel connects South Mumbai with the western suburbs. The cable-stayed bridge offers breathtaking views, especially at night."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is famous for street shopping, fashion accessories, handicrafts, and souvenirs. Don't miss Café Mondegar and Leopold Café for a quick bite."
    },
    {
        "title": "Sanjay Gandhi National Park & Kanheri Caves",
        "description": "A green escape within Mumbai, Sanjay Gandhi National Park offers nature trails, a toy train, and a lion & tiger safari. The Kanheri Caves, located within the park, are ancient Buddhist rock-cut structures."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its Mumbai street food, Juhu Beach is a perfect place to enjoy the sunset and unwind. It’s also known for celebrity homes, including Amitabh Bachchan’s bungalow."
    }
],

"services": [
    {
        "name": "Mumbai Airport Taxi Booking Online with Vedant Travels",
        "description": "Booking a taxi to Mumbai Airport has never been easier! With Vedant Travels, you can conveniently book your airport taxi online. Whether you're heading to the airport for a flight or arriving from one, we ensure you a smooth and stress-free ride."
    },
    {
        "name": "Mumbai Airport Cab Booking",
        "description": "Need a reliable taxi service to or from Mumbai Airport? Vedant Travels offers punctual and comfortable cab services for your airport journey. Our professional drivers and well-maintained vehicles ensure your ride is safe, smooth, and on time."
    },
    {
        "name": "Online Mumbai Airport Taxi",
        "description": "Booking a taxi for Mumbai Airport is quick and easy with Vedant Travels. You can reserve your ride online at your convenience, ensuring you have a hassle-free journey to the airport. Enjoy the convenience and comfort of a professional taxi service."
    },
    {
        "name": "Mumbai to Airport Taxi Fare",
        "description": "Vedant Travels offers transparent and competitive taxi fares to Mumbai Airport. We provide fair pricing with no hidden charges, allowing you to plan your trip confidently. Contact us for an accurate fare quote based on your specific requirements."
    },
    {
        "name": "Mumbai Airport Taxi Services",
        "description": "Vedant Travels provides reliable and comfortable taxi services to Mumbai Airport. Whether you're catching a flight or arriving after a long journey, our services are designed to get you to and from the airport smoothly, on time, and with complete peace of mind."
    },
    {
        "name": "Mumbai Airport Drop Taxi",
        "description": "For a quick and reliable airport drop, Vedant Travels is your trusted choice. We offer efficient taxi services to drop you at Mumbai Airport in comfort. Our experienced drivers will ensure that you reach the airport in time, ready for your flight."
    },
    {
        "name": "Mumbai Airport One Way Cab",
        "description": "If you need a one-way taxi to Mumbai Airport, Vedant Travels offers affordable one-way cab services. Whether you're departing or arriving, our one-way taxi service ensures you a smooth and comfortable ride to or from the airport."
    },
    {
        "name": "Mumbai Airport Innova Booking",
        "description": "For a luxurious and spacious ride to Mumbai Airport, book an Innova with Vedant Travels. The Innova offers plenty of space and comfort, making it perfect for families or groups traveling to or from the airport. Book your Innova for an elevated airport travel experience."
    },
    {
        "name": "Mumbai Airport Cab Online Booking",
        "description": "Booking a cab to or from Mumbai Airport is easy with Vedant Travels’ online booking system. Simply reserve your ride online and enjoy a hassle-free, comfortable journey with professional drivers and well-maintained vehicles. Secure your ride today!"
    }
],



"tableData": [
    ["Mumbai Airport Taxi Booking Online", "Mumbai Airport Cab Booking"],
    ["Online Mumbai Airport Taxi", "Mumbai to Airport Taxi Fare"],
    ["Mumbai Airport Taxi Services", "Mumbai Airport Drop Taxi"],
    ["Mumbai Airport One Way Cab", "Mumbai Airport Innova Booking"],
    ["Mumbai Airport Cab Online Booking", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of timely arrivals and departures. Whether you're catching a flight or arriving at Mumbai Airport, our drivers ensure that you reach your destination on time, stress-free, and in comfort."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a relaxing ride with our fleet of spacious, well-maintained vehicles. From sedans to SUVs, we provide air-conditioned cars equipped with comfortable seating and ample legroom, making your airport journey smooth and comfortable."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly trained and experienced in handling airport transfers. They know the best routes to and from Mumbai Airport, ensuring a quick and safe journey. They are professional, courteous, and ready to assist you with your luggage."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing for your Mumbai Airport taxi service. We believe in no hidden charges, providing clear, upfront pricing so you can easily plan your travel expenses."
    },
    {
      "WhyChooseheading": "Safe and Secure Travel",
      "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring your peace of mind throughout the ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "No matter the time of day or night, Vedant Travels is available to serve your Mumbai Airport taxi needs. Our customer support team is always ready to assist with bookings or any last-minute changes to your travel plans."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai Airport taxi is easy and convenient with Vedant Travels. You can book online through our website or mobile app, or call our customer service team to assist you with your reservation, even on short notice."
    },
    {
      "WhyChooseheading": "Personalized Travel Experience",
      "WhyChoosedescription": "We understand that every traveler is different. Whether you need a taxi for a solo trip, a family, or a group, we can customize your ride according to your needs and preferences. We aim to make your airport travel experience as comfortable and convenient as possible."
    }
  ]

    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai Airport taxi with Vedant Travels?',
            answer: 'You can easily book a taxi online via our website or mobile app. Alternatively, you can reach out to our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Do you offer both pickup and drop services from Mumbai Airport?',
            answer: 'Yes, we offer both pickup and drop services. Whether you\'re arriving at Mumbai Airport or need a ride to the airport, Vedant Travels is here to serve you.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai Airport transfers?',
            answer: 'We offer a wide range of well-maintained vehicles, including sedans, SUVs, and luxury cars, all equipped with air conditioning and ample space for a comfortable journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai Airport taxi rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Are there any additional charges for airport pickups or drop-offs?',
            answer: 'Any additional charges, such as airport parking fees or tolls, will be communicated upfront. We believe in complete transparency in our pricing structure.',
        },
        {
            id: 6,
            question: 'Can I book a round-trip taxi to and from Mumbai Airport?',
            answer: 'Yes, you can book a round-trip taxi for your Mumbai Airport transfer. Just provide your return details during the booking process, and we will ensure a seamless trip back.',
        },
        {
            id: 7,
            question: 'What happens if my flight is delayed?',
            answer: 'No worries! We monitor flight timings, so if your flight is delayed, our driver will adjust accordingly to ensure you’re picked up on time, no matter when you arrive.',
        },
        {
            id: 8,
            question: 'Can I book a taxi for group travel to Mumbai Airport?',
            answer: 'Yes, we provide taxi services for group travel. Whether you\'re traveling with family, friends, or colleagues, we can arrange a suitable vehicle to accommodate your group comfortably.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate airport transfers?',
            answer: 'Yes, we offer corporate airport transfer services. Whether you need transportation for executives, meetings, or conferences, Vedant Travels provides a professional and comfortable experience.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai Airport taxi bookings?',
            answer: 'Vedant Travels offers a reliable, comfortable, and affordable taxi service with experienced drivers, well-maintained vehicles, and transparent pricing. Whether you\'re traveling for business or leisure, we make your Mumbai Airport transfer seamless and stress-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Kumar",
            title: "Traveler",
            quote: "I had a wonderful experience with Vedant Travels for my airport transfer. The booking process was simple, and the driver was prompt, professional, and courteous. The ride was comfortable, and I reached the airport on time!",
            rating: 5,
        },
        {
            name: "Mrs. Priya Desai",
            title: "Business Traveler",
            quote: "I frequently use Vedant Travels for my business trips to Mumbai, and their airport taxi service never disappoints. The cars are always clean, and the drivers are well-trained. I can always rely on them for a smooth and punctual airport transfer.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   

 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Taxi Booking Online",
  "image": "https://vedanttravels.in/assets/images/mumbai-airport-taxi-booking-online.jpg",
  "description": "Book your Mumbai airport taxi online with Vedant Travels for hassle-free and timely pickups and drop-offs. Choose from AC sedans, SUVs, and tempo travellers for comfortable airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "899",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-airport-taxi-booking-online"
  }
};



  


    return (
        <div>
              <Helmet>
  <title>Mumbai Airport Taxi Booking Online | Hassle-Free Airport Transfers | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book your Mumbai airport taxi online with Vedant Travels for hassle-free and timely pickups and drop-offs. Choose from AC sedans, SUVs, and tempo travellers for comfortable airport transfers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport Taxi Booking Online, Mumbai Airport Cab Booking, Online Taxi Booking Mumbai Airport, Vedant Travels Airport Taxi, AC Cab Mumbai Airport, Airport Transfer Mumbai, Taxi Booking Online Mumbai Airport, Comfortable Airport Cab Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mubaiairporttaxibookingonline;